import React, { Fragment } from 'react'
import { Menu } from 'antd';
import {AppButtonDemo,AppEventDemo,
    AppInputDemo,AppSelectDemo,AppDateDemo,AppRadioDemo,
    AppTextDemo,AppTableDemo,AppTableSearchDemo,AppLookupDemo,
    AppTabsDemo,AppGridLayoutDemo,AppGridBarDemo,AppFormDemo
} from './components'
import './AppPlatform.less'
import {AppPopover} from 'qcc'

export const AppPlatform = () =>{

const[current,setCurrent] = React.useState('AppForm');

const renderDemo = () =>{
    switch (current){
        case 'AppButton':
            return <AppButtonDemo />
        case 'AppInput':
            return <AppInputDemo/>
        case 'AppEvent':
            return <AppEventDemo/>
        case 'AppSelect':
            return <AppSelectDemo/>
        case 'AppDate':
            return <AppDateDemo/>
        case 'AppRadio':
            return <AppRadioDemo/>
        case 'AppText':
            return <AppTextDemo/>
        case 'AppLookup':
            return <AppLookupDemo/>
        case 'AppForm':
            return <AppFormDemo/>
        case 'AppTable':
            return <AppTableDemo/>
        case 'AppTableSearch':
            return <AppTableSearchDemo/>
        case 'AppTabs':
            return <AppTabsDemo/>
        case 'AppGridLayout':
            return <AppGridLayoutDemo/>
        case 'AppGridBar':
            return <AppGridBarDemo/>
    }

    return <Fragment/>
}

    return (<div className='app-demo-platform'>
        <div className='app-demo-main' onScroll={handleScroll}>
            <div>
                <Menu onClick={e=>setCurrent(e.key)} selectedKeys={[current]} mode="horizontal">
                    <Menu.SubMenu title='按钮'>
                        <Menu.Item key="AppButton">AppButton(按钮)</Menu.Item>
                        <Menu.Item key="AppEvent">AppEvent(操作事件)</Menu.Item>
                    </Menu.SubMenu>
                    <Menu.SubMenu title='数据录入'>
                        <Menu.Item key="AppInput">AppInput(输入框)</Menu.Item>
                        <Menu.Item key="AppSelect">AppSelect(选择框)</Menu.Item>
                        <Menu.Item key="AppDate">AppDate(时间输入框)</Menu.Item>
                        <Menu.Item key="AppRadio">AppRadio(单选框)</Menu.Item>
                        <Menu.Item key="AppText">AppText(多行文本)</Menu.Item>
                        <Menu.Item key="AppLookup">AppLookup(查找输入)</Menu.Item>
                        <Menu.Item key="AppForm">AppForm(Form表单)</Menu.Item>
                    </Menu.SubMenu>
                    <Menu.SubMenu title='数据展示'>
                        <Menu.Item key="AppTabs">AppTabs(标签页)</Menu.Item>
                        <Menu.Item key="AppTable">AppTable(表格)</Menu.Item>
                        <Menu.Item key="AppTableSearch">AppTableSearch(查询)</Menu.Item>
                        <Menu.Item key="AppGridBar">AppGridBar(网格页面功能条)</Menu.Item>
                        <Menu.Item key="AppGridLayout">AppGridLayout(一级页面布局)</Menu.Item>
                    </Menu.SubMenu>
                </Menu>
            </div>
            {renderDemo()}
        </div>
    </div>)
}


const handleScroll = () =>{
    AppPopover.close();
}


// WEBPACK FOOTER //
// ./src/demo/AppPlatform.tsx